import { debounce } from '../../../common/utils';

import els from './elements';

let context = null;

const prepare = () => {

    context = gsap.context(() => {

        const $story = els.$story();
        const $banner = els.$banner();
        const $image = els.$bannerImage();

        gsap.set(
            $image,
            {
                xPercent: -50,
                left: '50%',
                height: $banner.height() * 1.25,
            }
        );

        gsap.fromTo(
            $image,
            {
                top: 0,
                yPercent: 0,
            },
            {
                top: '100%',
                yPercent: -100,
                scrollTrigger: {
                    trigger: $banner,
                    start: 'top bottom',
                    end: 'bottom top',
                    scrub: 2,
                    pinnedContainer: $story,
                },
            }
        );
    });
};

const cleanUp = () => {

    context?.revert();
};

const initialize = () => {

    prepare();

    $(window).on(
        'resize:horizontally',
        debounce(
            () => {
                cleanUp();
                prepare();
            },
            50
        )
    )
};

export default {
    initialize,
};

